import React from 'react';

import { IGroupMember, IGroup } from '../../store/group/groupState';
import Button from '../../components/forms/button/Button';
import Spinner, { SpinnerSize } from '../../components/shared/spinner/Spinner';
import Icon from '../../components/shared/icon/Icon';
import Member from './Member';
import getConfiguration from '../../services/environment';

interface IOwnProps {
    title: string;
    group: IGroup | undefined;
    members: IGroupMember[];
    isDi: boolean;
    download: (e: React.FormEvent<HTMLButtonElement>) => void;
    downloading: boolean;
}

type Props = IOwnProps;

let selfServiceAuthority = 'https://dit.di.dk/';

class Members extends React.Component<Props, {}> {
    public async componentDidMount() {
        selfServiceAuthority = (await getConfiguration()).selfServiceAuthority;
    }

    public render() {
        const participants = this.props.members.filter(m => m.role !== 'Responsible' && m.role !== 'Coordinator');
        let smi = 'none';

        if (this.props && this.props.group) {
            if (this.props.group.showMembersInfo) {
                smi = this.props.group.showMembersInfo
            } else if (this.props.group.showMembers) {
                smi = 'all';
            }
        }

        return <section className="section">
            <div className="deck">
                <div className="w--md banner-title">
                    <h1>{this.props.title}{!participants.length || !this.props.group || !this.props.group.enabled || smi === 'none' ? null : ` (${participants.length})`}</h1>

                    {this.props.isDi && this.props.group ?
                        <React.Fragment>
                            <a href={`Group/${this.props.group.alias}/stats`} className="button button--action has-icon">
                                <span className="text">
                                    <span className="icon icon--right-spacing">
                                        <Icon name="graph" />
                                    </span>
                                    Deltagerstatistik
                                    </span>
                            </a><br /><br />
                        </React.Fragment> : null
                    }

                    {this.props.isDi && this.props.group ?
                        <React.Fragment>
                            <a href={`Group/${this.props.group.alias}/maintenance`} className="button button--action has-icon">
                                <span className="text">
                                    <span className="icon icon--right-spacing">
                                        <Icon name="meninger" />
                                    </span>
                                    Vedligehold deltagere
                                    </span>
                            </a><br /><br />
                        </React.Fragment> : null
                    }
                </div>
            </div>
            <div className="deck">
                <div className="w--md">
                    {this.props.group && this.props.group.enabled && smi !== 'none' &&
                        <React.Fragment>
                            {!this.props.members.length ? <Spinner size={SpinnerSize.Large} /> :
                                <div className="flex-grid no-spread align-left">
                                    {participants.map((member, index) => {
                                        return <div className="flex-grid__col flex-grid__col--12 flex-grid__col--xs-4 flex-grid__col--sm-4 flex-grid__col--md-4" key={index}>
                                            <Member member={member} />
                                        </div>;
                                    })}
                                </div>}
                            {this.props.isDi ?
                                <React.Fragment>
                                    <a href={selfServiceAuthority} target="_blank" rel="nofollow noopener noreferrer" className="link">Gå til Min side</a> for at tilføje eller fjerne personer i gruppen. Find den person det drejer sig om, eller opret en ny person, og gå herefter til oversigten over udvalg og netværk.<br /><br />
                                    <Button modifierClass="button--small button--primary" disabled={this.props.downloading} onClick={this.handleClick} spinning={this.props.downloading}>Eksport til Excel</Button>
                                </React.Fragment> : null
                            }
                        </React.Fragment>
                    }
                    {this.props.group && this.props.group.enabled && smi === 'none' &&
                        <p>
                            {this.props.isDi
                                ? 'Deltagerlisten for gruppen er skjult. Du kan aktivere visning af listen under praktisk info øverst. Hvis den aktiveres vil den være synlig for alle deltagere.'
                                : 'Deltagerlisten er skjult. Kontakt den ansvarlige for gruppen for at få informationer om de andre deltagere.'
                            }
                        </p>
                    }
                    {this.props.group && !this.props.group.enabled &&
                        <p>
                            Der vises ikke medlemmer for denne gruppe.
                            {this.props.group.id.substring(0, 2) === 'ud'
                                ? ' Hvis du ønsker at give medlemmerne af netværket/udvalget adgang til en oversigt over de øvrige medlemmer, så skal du aktivere "Vis på web" i Membercare.'
                                : this.props.group.id.substring(0, 2) === 'ab'
                                    ? ' Hvis du ønsker at give medlemmerne af netværket adgang til en oversigt over de øvrige medlemmer, så skal du angive kategori "Netværk (...)" på abonnement definitionen i Membercare.'
                                    : ' Hvis du ønsker at give deltagerne på arrangementet adgang til en oversigt over de øvrige deltagere, så skal du aktivere "Vis på web" på arrangementet i Membercare.'
                            }
                        </p>
                    }
                </div>
            </div>
        </section>;
    }

    private handleClick = (e: React.FormEvent<HTMLButtonElement>) => {
        e.persist();

        if (this.props.download) {
            this.props.download(e);
        }
    }
}

export default Members;